import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { AddressDTO } from 'src/app/demo/model/AddressDTO';
import { InvoiceDTO } from 'src/app/demo/model/InvoiceDTO';
import { SchoolDTO } from 'src/app/demo/model/SchoolDTO';
import { TransactionDTO } from 'src/app/demo/model/TransactionDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';
import { profielBackgroundColor } from '../../constants/profielBackgroundColor';
import html2pdf from 'html2pdf.js';

@Component({
    selector: 'app-view-transaction-recipent',
    templateUrl: './view-transaction-recipent.component.html',
    styleUrls: ['./view-transaction-recipent.component.scss'],
})
export class ViewTransactionRecipentComponent implements OnInit {
    @ViewChild('printContent') printContent!: ElementRef;
    showSchoolLogo: boolean = true;
    onSchoolLogoError() {
        this.showSchoolLogo = false;
    }
    getBackgroundColor(roomId: number): string {
        if (!roomId) return profielBackgroundColor[0];
        const index = (roomId - 1) % profielBackgroundColor.length;
        return profielBackgroundColor[index];
    }
    invoiceData: DynamicDialogConfig<any>;
    transaction!: TransactionDTO;
    schoolDetails!: SchoolDTO;
    addressDetails!: AddressDTO;

    constructor(
        public config: DynamicDialogConfig,
        private formBuilder: FormBuilder,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private datePipe: DatePipe,
        private elementRef: ElementRef
    ) {
        this.invoiceData = this.config;

        if (this.invoiceData.data.viewTransaction) {
            this.transaction = this.invoiceData.data.transaction;
            this.schoolDetails = this.invoiceData.data.schoolDetails;
            this.addressDetails = this.invoiceData.data.address;
        }
    }

    ngOnInit(): void {
        this.lookupService
            .queryDocumentByPhotoUid(this.invoiceData.data.schoolDetails?.logo)
            .subscribe((response: HttpResponse<Blob>) => {
                const body = response?.body;
                if (body) {
                    const url = this.createImgFromBuffer(body);
                    this.invoiceData.data.schoolDetails.profileimg = url;
                }
            });

        //## start of logic
        // updated the student profile images in View payment receipt for all students
        if (this.transaction?.students?.length) {
            this.transaction.students.forEach((student: any) => {
                if (student.photoUuid) {
                    this.lookupService
                        .queryDocumentByPhotoUid(student.photoUuid)
                        .subscribe(
                            (response2: HttpResponse<Blob>) => {
                                const body = response2?.body;
                                if (body) {
                                    const url = this.createImgFromBuffer(body);
                                    student.profileimg = url;
                                } else {
                                    student.profileimg = undefined;
                                }
                            },
                            () => {
                                student.profileimg = undefined;
                            }
                        );
                } else {
                    student.profileimg = undefined;
                }
            });
        }
        // ## end of logic
    }
    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }

    printReceipt(isView: boolean = false) {
        const element = this.printContent.nativeElement;
        const clonedElement = element.cloneNode(true) as HTMLElement;

        // Remove no-print elements
        clonedElement.querySelectorAll('.no-print').forEach(el => el.remove());

        // Remove dialog header if present
        const dialogHeader = clonedElement.querySelector('.p-dialog-header');
        if (dialogHeader) {
          dialogHeader.remove();
        }

        const options = {
          margin: 0.5,
          filename: `transaction_${this.transaction.id || 'transaction'}.pdf`,
          image: { type: 'jpeg' as 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, allowTaint: true },
          jsPDF: { unit: 'in' as 'in', format: 'letter' as 'letter', orientation: 'portrait' as 'portrait' }
        };

        const worker = html2pdf().set(options).from(clonedElement);

        if (isView) {
          // ✅ VIEW → open in new tab (no download)
          worker.toPdf().get('pdf').then((pdf: any) => {
            const blobUrl = pdf.output('bloburl');
            window.open(blobUrl, '_blank');
          });
        } else {
          // ✅ DOWNLOAD → force download
          worker.save();
        }
      }

    restoreRemovedElements() {
        const selectors = [
            '.no-print',
            '.p-dialog-title',
            '.p-dialog-header-icons',
        ];

        selectors.forEach((selector) => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element) => {
                element.classList.remove('hidden');
            });
        });
    }

    getInitials(name: string): string {
        const words = name?.trim().split(/[-\s]+/); // Split by space or hyphen
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }
}
